module.exports = __webpack_public_path__ + "6165c76211301dfe4b0089be526c15d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/games/sm_image_mobile.jpg
// module id = 272
// module chunks = 0